import { colors, VStack } from "goi_common";
import { PropsWithChildren, ReactNode } from "react";

interface Props {
  disabled?: boolean;
  backgroundColor?: string;
  hasLinearGrad?: boolean;
  onClick?: () => void;
  bottom?: number;
  topMessage?: ReactNode;
}

const FixedSubmitButton = ({
  disabled,
  hasLinearGrad = true,
  backgroundColor = colors.orange650,
  children,
  onClick,
  bottom = 0,
  topMessage,
}: PropsWithChildren<Props>) => {
  return (
    <VStack
      id="fixed_sbmit_btn"
      css={{
        position: "fixed",
        width: "100%",
        bottom: bottom,
        left: 0,
        alignItems: "center",
        zIndex: 10,
      }}
    >
      {hasLinearGrad ? (
        <div
          css={{
            height: "34px",
            width: "100%",
            background: `linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, ${colors.white} 100%)`,
          }}
        />
      ) : (
        <div
          css={{
            height: "6px",
            width: "100%",
            background: "white",
          }}
        />
      )}
      <div
        css={{
          width: "100%",
          padding: "0px 20px 12px",
          backgroundColor: colors.white,
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          gap: topMessage ? "8px" : "0",
        }}
      >
        {topMessage && <div>{topMessage}</div>}
        <button
          className="white button_16_sb"
          css={{
            height: "50px",
            maxWidth: "480px",
            width: "100%",
            borderRadius: "5px",
            backgroundColor: disabled
              ? colors.gray200
              : backgroundColor
              ? backgroundColor
              : colors.orange650,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          disabled={disabled}
          onClick={onClick}
        >
          {children}
        </button>
      </div>
    </VStack>
  );
};

export default FixedSubmitButton;
